import { useCallback, useContext, useEffect } from 'react';

import { track } from 'analytics/frontend';
import UserContext from 'contexts/User';

import { COMPLETED_NAVIGATOR_STEP, STARTED_NAVIGATOR_STEP } from './constants';
import Steps from './steps';

const useNavigatorTracking = (step: Steps) => {
  const { uuid } = useContext(UserContext);

  useEffect(() => {
    track(STARTED_NAVIGATOR_STEP, {
      step,
      userId: uuid,
    });
  }, []);

  return useCallback(
    () =>
      track(COMPLETED_NAVIGATOR_STEP, {
        step,
        userId: uuid,
      }),
    [step, uuid]
  );
};

export default useNavigatorTracking;
